<template>
<w-sliding-popup ref="slidingPopup" title="관리대상 설정" width="900px" @close="close">
  <div slot="content">
    <w-device-auth-setting ref="deviceAuthSetting" :show-flag="isActive" :active="isActive" :checked-obj-list="checkedObjList"/>
  </div>
  <div slot="footer">
    <el-button size="large" type="solid" @click="onSaveClick">저장</el-button>
    <el-button size="large" @click="closePopup">취소</el-button>
  </div>
</w-sliding-popup>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

import ManagetypeAPI from '@/api/model/managetype';
import MapConst from '@/constants/topologymap';
import WDeviceAuthSetting from '@/views/settings/basic/UserAndAuthManagement/UserSettings/components/DeviceAuthSetting';

export default {
  name: 'WSettingObjOfCustomObjectPopup',
  components: {
    WDeviceAuthSetting,
  },
  data() {
    return {
      MapConst,
      managetypeList: [],
      checkedObjList: [],
      saveCheckedObjList: [],
      originCheckedObjList: [],
      isActive: false,
      changeFlag: false,
    };
  },
  methods: {
    open(objs = []) {
      if (objs.length > 0) {
        this.checkedObjList = objs;
        this.originCheckedObjList = cloneDeep(objs);
      }
      ManagetypeAPI.getManagetypeInfo().then((response) => {
        if (response.data.success) {
          this.managetypeList = response.data.data;
          this.$refs.slidingPopup.open();
        }
      });
      this.isActive = true;
    },
    closePopup() {
      this.$refs.slidingPopup.close();
    },
    close() {
      if (!this.isActive) {
        return;
      }
      const data = this.changeFlag ? this.saveCheckedObjList : this.originCheckedObjList;
      this.$emit('close', data);
      this.initData();
    },
    onSaveClick() {
      const tempCheckedObjList = this.$refs.deviceAuthSetting.$refs.selectedObjTable.checkedObjList;
      tempCheckedObjList.forEach((checkedObj) => {
        const tempObj = {
          managetypeName: checkedObj.managetypeName,
          objId: checkedObj.objId,
          objName: checkedObj.objName,
          objIp: checkedObj.objIp || checkedObj.ipaddress,
        };
        this.saveCheckedObjList.push(tempObj);
      });
      this.changeFlag = true;
      this.closePopup();
    },
    initData() {
      this.isActive = false;
      this.changeFlag = false;
      this.checkedObjList = [];
      this.managetypeList = [];
      this.originCheckedObjList = [];
      this.saveCheckedObjList = [];

      this.$refs.deviceAuthSetting.initData();
    },
  },
};
</script>

<style module>
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/popup/SettingObjOfCustomObjectPopup.vue